import styled from "styled-components";

export const SpotlightRaySvgBox = styled.svg<{zIndex: number;}>`
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: ${({zIndex}) => zIndex};
    pointer-events: none;
`;
